export default "__VITE_ASSET__1qB$kAkR__"